// @flow

import MainApi from "./MainApi"

export const BASE_URL = "fleet-rc-gateway/api"

export default {
  /*
  Vehicles
   */
  vehicles: {
    getVehiclesByFleet: async ({
      fleetId
    }: {
      fleetId: number
    }): Promise<any> => {
      const { data } = await MainApi.get(
        `${BASE_URL}/vehicles?fleetId=${fleetId}`
      )
      return data
    },
    getVehicle: async ({ regNr }: { regNr: string }): Promise<any> => {
      const { data } = await MainApi.get(`${BASE_URL}/vehicles/${regNr}`)
      return data
    },
    createVehicle: async ({ data }: { data: Object }): Promise<any> => {
      const response = await MainApi.post(`${BASE_URL}/vehicles`, data)
      return response
    },
    updateVehicle: async ({ regNr, data }: { regNr: string, data: Object }) => {
      await MainApi.put(`${BASE_URL}/vehicles/${regNr}`, data)
    },
    deleteVehicle: async ({ regNr }: { regNr: string }) => {
      await MainApi.delete(`${BASE_URL}/vehicles/${regNr}`)
    },
    createNotice: async ({ regNr, data }: { regNr: string, data: Object }) => {
      await MainApi.post(`${BASE_URL}/vehicles/${regNr}`, data)
    }
  },

  /*
  Fleets
   */
  fleets: {
    getAllFleets: async (): Promise<any> => {
      const result = await MainApi.get(`${BASE_URL}/fleets`)
      return result
    }
  },

  /*
  Organizations
   */
  organizations: {
    getAllOrganizations: async (): Promise<any> => {
      const { data } = await MainApi.get(`${BASE_URL}/organizations`)
      return data
    },
    createOrganization: async ({ data }: { data: Object }) => {
      await MainApi.post(`${BASE_URL}/organizations`, data)
    }
  },

  /*
  skatteverket
   */
  skatteverket: {
    createDeviation: async ({ data }: { data: Object }) => {
      await MainApi.post(`${BASE_URL}/skatteverket/send/deviation`, data)
    },
    createNotice: async ({ data }: { data: Object }) => {
      await MainApi.post(`${BASE_URL}/skatteverket/send/notice`, data)
    },
    createShift: async ({ data }: { data: Object }) => {
      await MainApi.post(`${BASE_URL}/skatteverket/send/shift`, data)
    },
    getScheduledJobs: async (): Promise<any> => {
      const response = await MainApi.get(`${BASE_URL}/scheduledJobs`)
      return response
    }
  }
}
